import React from "react";
import styles from "./style.module.css";

function Heath({ color }) {
  return <div className={styles.container} style={{ background: color }}></div>;
}

export default Heath;
